export const SUBSCRIPTION_ACCOUNT_STATUS = {
    LINKED: "linked",
    IN_METERING_GROUP: "in_metering_group",
    ASSOCIATE_PENDING: "associate_pending",
    ASSOCIATE_SUCCESS: "associate_success",
    NULL: "null"
};

export const SUPPORT_ENHANCED: string = "Enhanced";
export const SUPPORT_ESSENTIAL: string = "Essential";
export const SUPPORT_PREMIUM: string = "Premium";
export const SUPPORT_STANDARD: string = "Standard";

export const STATUS_PENDING: string = "Pending";
export const STATUS_SUCCESS: string = "Success";
export const STATUS_FAILED: string = "Failed";
